import styled from "styled-components";
import {Button, Grid, Modal} from "antd";
import {useMemo} from "react";
import {useNavigate} from "react-router-dom";

const {useBreakpoint} = Grid

const ItemWrapper = styled.div`
  margin-top: 20px;
  background: #0E0E0E;
  border-radius: 5px;
  padding: 28px 34px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 19px 14px;
    margin-top: 11px;
  }
`

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  flex: 1;
  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`

const Rewards = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
  flex: 1;
  display: flex;
  align-items: center;
  > span {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 24px;
  }
  @media screen and (max-width: 768px) {
    font-size: 13px;
    > span {
      font-size: 13px;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex: 1;
  margin-left: 22px;
  @media screen and (max-width: 768px) {
    display: block;
  }
`

const ViewButton = styled(Button)`
    width: 120px;
    height: 40px !important;
    border-radius: 20px !important;
    border-color: #6ee6c6 !important;
    color:#6ee6c6 !important;
    &:hover{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    }
`

export const ContestItem = ({contest}) => {
    const breakpoint = useBreakpoint();
    const navigate = useNavigate()

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

    const imageSize = isMobile ? 47 : 60

    const toDetail = () => {
        if (contest.contest_permission) {
            const name = encodeURIComponent(contest.contest_name)
            navigate(`/bounties/${name}?type=2`)
        } else {
            Modal.warn({
                title: 'The Contest is only open to invited whitehats. The application channel will be open soon. Please stay tuned.',
                okText: 'Got it',
                okButtonProps: {
                    type: 'primary',
                    style: {
                        backgroundColor: '#18EAC4',
                        borderColor: '#18EAC4',
                        color: '#000',
                        borderRadius: '4px',
                    }
                },
            })
        }
    }

    const handleClick = () => {
        if (isMobile) {
            toDetail()
        }
    }

    return (
        <ItemWrapper onClick={handleClick}>
            <img width={imageSize} height={imageSize} src={contest.category.logo_file} alt=""/>
            <Content>
                <Title>{contest.contest_name}</Title>
                <Rewards>Rewards up to&nbsp;&nbsp;<span>{contest.max_reward.toLocaleString(navigator.language)} {contest.reward_symbol}</span></Rewards>
            </Content>
            {
                isMobile ? (
                    <img width={8} src={require('../../../assets/images/icons/arrow-right.png')}  alt=''/>
                ) : (
                    <ViewButton onClick={(e) => {
                        e.stopPropagation()
                        toDetail()
                    }}>View</ViewButton>
                )
            }

        </ItemWrapper>
    )
}